import { Button, ButtonGroup } from "react-bootstrap";
import {
  Control,
  FieldPath,
  FieldValues,
  useController,
} from "react-hook-form";

const ConditionToggle = <TForm extends FieldValues>({
  name,
  control,
}: {
  name: FieldPath<TForm>;
  control: Control<TForm>;
}) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
  });

  return (
    <ButtonGroup>
      <Button
        variant={value === "and" ? "primary" : "light"}
        style={
          value !== "and"
            ? { opacity: 0.6, textDecoration: "line-through", color: "#6c757d" }
            : undefined
        }
        onClick={() => onChange("and")}
      >
        AND
      </Button>
      <Button
        variant={value === "or" ? "primary" : "light"}
        style={
          value !== "or"
            ? { opacity: 0.6, textDecoration: "line-through", color: "#6c757d" }
            : undefined
        }
        onClick={() => onChange("or")}
      >
        OR
      </Button>
    </ButtonGroup>
  );
};

export default ConditionToggle;
